import { Footer } from '../Components/Footer/FooterComponent';
import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { NavMobile } from '../Components/Inicio//NavMobile';
import SponsorsComponent from '../Components/Patrocinadores/SponsorsComponent';

export const SponsorsPage = (props) => {

    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <SponsorsComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}
